import { render } from "./NewsDropDown.vue?vue&type=template&id=87f7517c&scoped=true&ts=true"
import script from "./NewsDropDown.vue?vue&type=script&lang=ts"
export * from "./NewsDropDown.vue?vue&type=script&lang=ts"

import "./NewsDropDown.vue?vue&type=style&index=0&id=87f7517c&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\map-web-doson\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f7517c"]])

export default __exports__